import '@babel/polyfill';
import { LicenseManager } from '@ag-grid-enterprise/core';
import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

// imports modules from common package
import { Authentication, Layout, Modal, Utils, UI, Data } from 'common';
import MailCommunication from './components/utils/MailCommunication';
import MailView from './components/MailView.component';

const { SignIn } = Authentication;
const { Viewport, RegionType } = Layout;
const { ModalContainer } = Modal;
const { Analytics, Session, StyleLoader, Util } = Utils;
const { Spinner } = UI;
const { CalculatedData } = Data;

LicenseManager.setLicenseKey(__AG_GRID_LICENSE__);

export default class App extends Component {
	constructor(props) {
		super(props);

		const page = 'Mail';

		// initialize Session with sessionTimeout handler
		Session.init(
			{
				Page: page,
			},
			this.triggerTimeout
		);

		// initialize MailCommunication
		MailCommunication.init({
			resetTimeout: Session.resetTimeout,
			triggerTimeout: this.triggerTimeout,
		});

		this.state = {
			data: {
				InternalAccountInfo: true,
			},
			page,
			showMask: false,

			// `true` to show Sign-In overlay
			showSignIn: false,
			stylesLoaded: false,
		};

		this.verifyAuthAndLoadSession();
	}

	sessionLoadCallback = async () => {
		const sessionData = Session.getData();
		const { brand, isSignedIn } = sessionData;
		const { brandName } = brand;
		const { page } = this.state;

		// update document title
		document.title = `${brandName} | ${page}`;

		// load the theme bundle
		StyleLoader.loadTheme(brandName, this.setState({ showMask: true, stylesLoaded: true }));

		// initialize analytics
		Analytics.set({
			...sessionData,
			role: Session.getUserRole(),
		});

		// make a call to carrier-services api
		if (isSignedIn === true) {
			const shipDate =
				Util.getQueryParamByName('dt') || new Date().toISOString().split('T')[0];
			const response = await MailCommunication.getCarrierServices(shipDate);
			const data = MailCommunication.isSuccessful(response)
				? Util.toCamelCase(response.data)
				: null;

			CalculatedData.init(data);
		}

		this.setState({
			showMask: false,
		});
	};

	triggerTimeout = () => {
		const { isSignedIn } = Session.getData();

		if (isSignedIn) {
			this.showSignInView();
		}
	};

	// show Sign-In view when user clicks the Sign In button in the mobile view
	showSignInView = () => {
		this.setState({
			showSignIn: true,
		});
	};

	verifyAuthAndLoadSession = () => {
		const { data } = this.state;

		Session.verifyAuthAndLoad(data, this.sessionLoadCallback);
	};

	signInCallback = ({ status }) => {
		if (status) {
			this.setState(
				{
					showMask: true,
					showSignIn: false,
				},
				this.verifyAuthAndLoadSession
			);
		}
	};

	render() {
		const { page, showMask, showSignIn, stylesLoaded } = this.state;
		const layout = {
			[RegionType.North]: {
				height: showSignIn ? 0 : 50,
			},
		};

		if (!stylesLoaded) {
			return null;
		} else if (showMask) {
			return <Spinner msg={`Loading ${page}`} />;
		} else if (showSignIn) {
			return (
				<Viewport layout={layout} shouldScroll={showSignIn}>
					<ModalContainer>
						<SignIn signInCallback={this.signInCallback} />
					</ModalContainer>
				</Viewport>
			);
		}

		return (
			<MailView showSignInView={this.showSignInView} signInCallback={this.signInCallback} />
		);
	}
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
